<!-- <div class= "modal-dialog">
  <div class= "modal-content"style="padding: 16px;">
    <div class= "modal-header"  >  
     <mat-toolbar>Edit Persons Involved</mat-toolbar>
    </div>
<div class ="modal-body" style="height: 600px !important;overflow-y: scroll;">
      
    <table class="sc-resultstable">
      <thead>
          <tr>
              <th>Include</th>
              <th>Person</th>
          </tr>
      </thead>
      <tbody>
        
                <ng-container *ngFor="let usr of users">
                  <tr>
                   
                      <td style="text-align: center;">
                            <ng-container *ngIf="personsInvolved != null && personsInvolved.includes(usr.UserAuto)">
                              <ng-container *ngIf="personsInvolved == null"> comment
                              <td  style="text-align: center; width: 10%"><mat-checkbox [checked]="true" (click)="onPersonsInvolvedChanged(usr.UserAuto, false)"></mat-checkbox></td>
                            </ng-container>
                            <ng-container *ngIf="personsInvolved == null ">comment
                            <ng-container *ngIf="personsInvolved == null || personsInvolved.includes(usr.UserAuto)">
                         
                              <td  style="text-align: center; width: 10%"><mat-checkbox  [checked]="false"  (click)="onPersonsInvolvedChanged(usr.UserAuto, true)"></mat-checkbox></td>
                          </ng-container>
                      </td>
                   

                     



                      <td style="text-align: center;">
                          {{usr.UserName}}
                      </td>
                  </tr>
                  </ng-container>
            
          
      </tbody>
  </table>


</div>
<div class="modal-footer">
    <div class="buttonbelow">
      <button mat-button (click) ="save()">Submit</button>
      <button mat-button  (click)="DialogClose()" >Cancel</button>    
    </div>
  </div>
</div>
</div> -->

<mat-toolbar>Add Persons Involved</mat-toolbar>


 <mat-form-field class="header-form-full-width" style="width: 100%;">
  <input type="text" placeholder="Search Persons"
 (input)="changeModelAutoCompleteAssetSerial($event)" matInput>
  
</mat-form-field>

<div class="modal-dialog" style="height: 600px !important;overflow-y: scroll;">
  <form>
    
    <table class="sc-resultstable">
      <thead>
          <tr>
              <th style="text-align: center;">Include</th>
              <th style="text-align: center;">Person</th>
          </tr>
      </thead>
      <tbody>
        
                <ng-container *ngFor="let usr of FilteredUsers">
                  <tr>
                   
                      <!-- <td style="text-align: center;">
                            <ng-container *ngIf="personsInvolved != null && personsInvolved.includes(usr.UserAuto)">
                              
                              <td  style="text-align: center; width: 10%"><mat-checkbox [checked]="true" (click)="onPersonsInvolvedChanged(usr.UserAuto, false)"></mat-checkbox></td>
                            </ng-container>
                           
                            <ng-container *ngIf="personsInvolved == null || personsInvolved.includes(usr.UserAuto)">
                         
                              <td  style="text-align: center; width: 10%"><mat-checkbox  [checked]="false"  (click)="onPersonsInvolvedChanged(usr.UserAuto, true)"></mat-checkbox></td>
                          </ng-container>
                      </td> -->

                      <td style="text-align: center;">
                        <ng-container *ngIf="personsInvolved != null && personsInvolved.includes(usr.UserAuto)">
                          <!-- <ng-container *ngIf="personsInvolved == null"> -->
                          <td  style="text-align: center; width: 10%"><mat-checkbox [checked]="true" (click)="onPersonsInvolvedChanged(usr.UserAuto, false)"></mat-checkbox> </td>
                        </ng-container>
                        <!-- <ng-container *ngIf="personsInvolved == null "> -->
                        <ng-container *ngIf="personsInvolved == null || !personsInvolved.includes(usr.UserAuto)">
                     
                          <td  style="text-align: center; width: 10%"><mat-checkbox  [checked]="false"  (click)="onPersonsInvolvedChanged(usr.UserAuto, true)"></mat-checkbox></td>
                      </ng-container>
                  </td>

                     



                      <td style="text-align: center;">
                          {{usr.UserName}}
                      </td>
                  </tr>
                  </ng-container>
            
          
      </tbody>
  </table>

   

      <div class="buttonbelow">
        <button mat-button (click) ="save()">Submit</button>
        <button mat-button  (click)="DialogClose()" >Cancel</button>  
      </div>
  </form>

</div>

